import { connect } from 'react-redux';
import { getProject } from 'project/ducks/project';
import { getProjectEntries } from 'project/ducks/entries';
import { getProjectRevisions } from 'project/ducks/revisions';
import RevisionStep from 'project/components/participate_form/revision_step';

function mapStateToProps(state) {
  return {
    project: getProject(state),
    revisions: getProjectRevisions(state),
    entries: getProjectEntries(state),
  };
}

export default connect(mapStateToProps, null)(RevisionStep);




// WEBPACK FOOTER //
// ./project/containers/participate_revision_step.jsx